import { css } from '@/styled-system/css';

export const assistChipAvatarStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  marginInlineEnd: 'tighter',
});
